import {createFileRoute} from '@tanstack/react-router'
import {
	Tabs,
	Container,
	SegmentedControl,
	Group,
	TextInput,
	Button,
	Title,
	LoadingOverlay,
	Tooltip
} from "@mantine/core";
import {IconFilter, IconPhone, IconRefresh} from "@tabler/icons-react";
import OrdersTable from "@components/ordersTable.tsx";
import {useReadyOrders} from "@state/server/orders.query.ts";
import {useEffect, useState} from "react";
import {useQueryClient} from "@tanstack/react-query";

const DNES_VYCHYSTANE = "Dnes Vychystané"
const VSECHNY = "Všechny"

export const Route = createFileRoute('/_authenticated/orders/_layout/ready')({
	component: RouteComponent,
})

function RouteComponent() {
	const [filterPhone, setFilterPhone] = useState<string>("")
	const [isToday, setIsToday] = useState<boolean>(false)
	const [isFiltered, setIsFiltered] = useState<boolean>(false)
	const {data, isLoading, refetch} = useReadyOrders(filterPhone, isToday)
	const queryClient = useQueryClient()

	const filter = async () =>{
		setIsFiltered(true)
		// await refetch()
	}

	const resetFilters = async ()=>{
		setFilterPhone("")
		setIsToday(false)
		setIsFiltered(false)
		await queryClient.invalidateQueries({queryKey: ["orders", "ready"]})
	}

	useEffect(() => {
		refetch()
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isFiltered]);


	return (
		<Tabs.Panel value={"ready"}>
			<Container fluid>
				<LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{radius: "sm", blur: 2}}/>
				<Title order={2} py={"md"}>Vychystané objednávky</Title>

				<Group p={"sm"}>
					<SegmentedControl
						fullWidth
						value={isToday ? DNES_VYCHYSTANE : VSECHNY} color={"zmrzlina-yellow"}
						data={[VSECHNY, DNES_VYCHYSTANE]}
						onChange={(v) => setIsToday(v === DNES_VYCHYSTANE)}
					/>

					<TextInput
						placeholder={"Telefonní číslo"} value={filterPhone}
						onChange={(e) => setFilterPhone(e.target.value)}
						leftSection={<IconPhone/>}
					/>
					<Button
						leftSection={<IconFilter/>}
						onClick={filter}
						loading={isLoading}
						disabled={isLoading}
					>
						Filtrovat
					</Button>
					<Tooltip label={"Obnovit filtry"}>
						<Button disabled={!isFiltered} variant={"light"} onClick={resetFilters}>
							<IconRefresh />
						</Button>
					</Tooltip>
				</Group>

				{data && <OrdersTable orders={data}/>}
			</Container>
		</Tabs.Panel>
	)
}
